module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/ui/notification-message/notification-message.component.scss
// module id = ./src/app/ui/notification-message/notification-message.component.scss
// module chunks = main